// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__13L8c","rootSmall":"AddTileButton_rootSmall__6Gu5R"};